import queryString from "query-string";
import {GET_REPORT_PLAN_CUSTOME} from "@/api/report_excel";
import {GET_REPORT} from "@/api/budget_monitor";

const state = {
    report_budget_plan: [],
    report: null,
};

const mutations = {
    SET_REPORT_BUDGET_PLAN: (states, payload) => {
        states.report_budget_plan = payload;
    },
    SET_REPORT: (states, payload) => {
        states.report = payload;
    },
};

const actions = {
    /*GET_REPORT_BUDGET_PLAN: async ({
                                     commit
                                 }, query) => {
        let dataquery = queryString.stringify(query);
        const resp = await GET_REPORT_PLAN_CUSTOME(dataquery);
        const data = resp.data.data;
        commit("SET_REPORT_BUDGET_PLAN", data);
    },*/
    GET_REPORT_BUDGET_PLAN: async ({
                           commit
                       }, body) => {
        // query = queryString.stringify(query);
        const resp = await GET_REPORT_PLAN_CUSTOME(body);
        const data = resp;
        commit("SET_REPORT_BUDGET_PLAN", data);
    },
    GET_REPORT: async ({
                           commit
                       }, type) => {
        // query = queryString.stringify(query);
        const resp = await GET_REPORT(type);
        const data = resp;
        commit("SET_REPORT", data);
    },
};

const getters = {
    report_budget_plan: (states) => states.report_budget_plan,
    report: (states) => states.report,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};